/* howtocolor-only — loaded only by qc-howtocolor-landing */
(function () {
  const root = document.querySelector('[data-qc-htc]');
  if (!root) return;

  const track = root.querySelector('[data-qc-htc-track]');
  const slides = Array.from(root.querySelectorAll('[data-qc-htc-slide]'));
  const dotsWrap = root.querySelector('[data-qc-htc-dots]');
  const thumbs = Array.from(root.querySelectorAll('[data-qc-htc-thumb]'));
  const form = root.querySelector('[data-qc-htc-form]');
  const errorEl = root.querySelector('[data-qc-htc-error]');
  const thanksEl = root.querySelector('[data-qc-htc-thanks]');
  const stickyBtn = root.querySelector('[data-qc-htc-sticky]');
  const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
  const cartClearUrl = root.dataset.cartClearUrl || '/cart/clear.js';
  const cartUpdateUrl = root.dataset.cartUpdateUrl || '/cart/update.js';

  let index = 0;

  function slideOffset(i) {
    return slides[i] ? slides[i].offsetLeft : i * (track ? track.clientWidth : 0);
  }

  function closestIndex() {
    if (!track || !slides.length) return 0;
    const left = track.scrollLeft;
    let best = 0;
    let bestDist = Infinity;
    slides.forEach(function (slide, i) {
      const dist = Math.abs(left - slide.offsetLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });
    return best;
  }

  function sync(i) {
    index = Math.max(0, Math.min(i, slides.length - 1));
    slides.forEach(function (slide, n) {
      slide.classList.toggle('is-active', n === index);
    });
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.qc-htc__dot').forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === index);
      });
    }
    thumbs.forEach(function (thumb, n) {
      thumb.classList.toggle('is-active', n === index);
    });
  }

  function goTo(i) {
    if (!track || !slides.length) return;
    sync(i);
    track.scrollTo({ left: slideOffset(index), behavior: 'smooth' });
  }

  if (track && slides.length) {
    slides.forEach(function (slide, i) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'qc-htc__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      dot.addEventListener('click', function () {
        goTo(i);
      });
      if (dotsWrap) dotsWrap.appendChild(dot);
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(Number(thumb.dataset.index || '0'));
      });
    });
    track.style.direction = 'ltr';
    track.addEventListener(
      'scroll',
      function () {
        sync(closestIndex());
      },
      { passive: true }
    );
  }

  const relatedTrack = root.querySelector('[data-qc-htc-related-track]');
  const relatedSlides = Array.from(root.querySelectorAll('[data-qc-htc-related-slide]'));
  const relatedDots = root.querySelector('[data-qc-htc-related-dots]');
  if (relatedTrack && relatedSlides.length) {
    relatedTrack.style.direction = 'ltr';
    relatedSlides.forEach(function (slide, i) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'qc-htc__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Produit ' + (i + 1));
      dot.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      if (relatedDots) relatedDots.appendChild(dot);
    });
    relatedTrack.addEventListener(
      'scroll',
      function () {
        const left = relatedTrack.scrollLeft;
        let best = 0;
        let bestDist = Infinity;
        relatedSlides.forEach(function (slide, i) {
          const dist = Math.abs(left - slide.offsetLeft);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        if (relatedDots) {
          relatedDots.querySelectorAll('.qc-htc__dot').forEach(function (dot, n) {
            dot.classList.toggle('is-active', n === best);
          });
        }
      },
      { passive: true }
    );
  }

  const packPrice = Number(root.dataset.packPrice || '9900');
  const packVariant = root.dataset.packVariant || '';
  const packBooks = root.dataset.packBooks || '';
  const packName = root.dataset.packName || 'Pack 4 livres';
  const totalEls = Array.from(root.querySelectorAll('[data-qc-htc-total], [data-qc-htc-sticky-total]'));

  function money(cents) {
    return Math.round(Number(cents) / 100) + ' dh';
  }

  function currentTotal() {
    return packPrice;
  }

  const totalText = money(packPrice);
  totalEls.forEach(function (el) {
    el.textContent = totalText;
  });
  if (form) {
    form.dataset.variant = packVariant;
    form.dataset.name = packName;
    form.dataset.books = packBooks;
    form.dataset.extras = '0';
    form.dataset.total = totalText;
  }

  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function showError(message) {
    if (errorEl) errorEl.textContent = message || '';
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function normalizePhone(phone) {
    var value = String(phone || '').replace(/[\s.-]/g, '');
    if (value.indexOf('+212') === 0) value = '0' + value.slice(4);
    else if (value.indexOf('212') === 0 && value.length > 9) value = '0' + value.slice(3);
    return value.replace(/\D/g, '');
  }

  function findEasySellVm(name) {
    const rootVm = window.easysellApp;
    if (!rootVm) return null;
    const stack = [rootVm];
    while (stack.length) {
      const vm = stack.pop();
      const vmName = (vm.$options && (vm.$options.name || vm.$options._componentTag)) || '';
      if (vmName === name) return vm;
      (vm.$children || []).forEach(function (child) {
        stack.push(child);
      });
    }
    return null;
  }

  function fillVueInput(el, value) {
    if (!el) return;
    const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    setter.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function fillEasySellField(orderForm, key, value) {
    const lists = [orderForm.inputFields, orderForm.fields];
    if (orderForm.$store && orderForm.$store.state && orderForm.$store.state.form) {
      lists.push(orderForm.$store.state.form.fields);
    }
    lists.forEach(function (list) {
      if (!list) return;
      list.forEach(function (field) {
        if (field.value !== key) return;
        if (orderForm.$set) orderForm.$set(field, 'model', value);
        else field.model = value;
        field.hasError = false;
        if (typeof orderForm.onFieldChange === 'function') {
          try {
            orderForm.onFieldChange(field);
          } catch (e) {
            /* ignore */
          }
        }
      });
    });
    fillVueInput(document.getElementById('es-' + key), value);
  }

  function easySellHasOrder(orderForm) {
    const formState = orderForm && orderForm.$store && orderForm.$store.state && orderForm.$store.state.form;
    return Boolean(document.getElementById('es-thanks-modal') || (formState && formState.order));
  }

  async function waitForEasySellOrder(orderForm, timeoutMs) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (easySellHasOrder(orderForm)) return true;
      await wait(200);
    }
    return easySellHasOrder(orderForm);
  }

  function easySellCart(orderForm) {
    return (
      orderForm &&
      orderForm.$store &&
      orderForm.$store.state &&
      orderForm.$store.state.cart &&
      orderForm.$store.state.cart.cart
    );
  }

  function applyPackPriceAndShipping(orderForm, packPriceCents) {
    const store = orderForm && orderForm.$store;
    if (!store || !store.state) return;
    const packPrice = Math.round(Number(packPriceCents) / 100);
    const cart = store.state.cart && store.state.cart.cart;
    if (cart && cart.items && cart.items.length && packPrice > 0) {
      cart.items.forEach(function (item) {
        item.line = packPrice;
        item.linePrice = packPrice;
        item.final_line_price = packPrice;
        item.price = packPrice;
        item.final_price = packPrice;
        item.discounted_price = packPrice;
      });
      cart.totalPrice = packPrice;
    }
    const option = {
      id: 'qc-htc-free',
      name: 'Livraison incluse',
      price: 0,
      hasCondition: false,
    };
    if (store.state.shipping) {
      store.state.shipping.options = [option];
      store.state.shipping.selectedOption = option;
    }
  }

  async function refreshEasySellCart(orderForm, app) {
    const store = orderForm && orderForm.$store;
    if (store && typeof store.dispatch === 'function') {
      try {
        await store.dispatch('cart/fetchCart');
      } catch (e) {
        /* ignore */
      }
      try {
        await store.dispatch('shipping/setShippingOptions');
      } catch (e) {
        /* ignore */
      }
    } else if (app && typeof app.fetchCart === 'function') {
      try {
        await Promise.resolve(app.fetchCart());
      } catch (e) {
        /* ignore */
      }
    }
    for (let i = 0; i < 20; i += 1) {
      const cart = easySellCart(orderForm);
      if (cart && cart.itemCount > 0) return true;
      await wait(150);
    }
    return Boolean(easySellCart(orderForm) && easySellCart(orderForm).itemCount > 0);
  }

  async function submitEasySellInBackground(customer) {
    const app = findEasySellVm('App') || window.easysellApp;
    const orderForm = findEasySellVm('OrderForm');
    if (!app || !orderForm || typeof orderForm.validateAndSubmit !== 'function') return false;
    document.body.classList.add('qc-es-silent');
    if (typeof app.enablePopupForm === 'function') {
      try {
        app.enablePopupForm();
      } catch (e) {
        /* ignore */
      }
    } else if (typeof app.onStickyButtonClick === 'function') {
      try {
        app.onStickyButtonClick();
      } catch (e) {
        /* ignore */
      }
    }
    await wait(300);
    await refreshEasySellCart(orderForm, app);
    applyPackPriceAndShipping(orderForm, customer.packPrice);
    orderForm.selectedCountryCode = 'MA';
    if (orderForm.$store && orderForm.$store.state && orderForm.$store.state.form) {
      orderForm.$store.state.form.country = 'MA';
    }
    fillEasySellField(orderForm, 'first_name', customer.name);
    fillEasySellField(orderForm, 'phone', customer.phone);
    fillEasySellField(orderForm, 'address', customer.address);
    applyPackPriceAndShipping(orderForm, customer.packPrice);
    await wait(150);
    if (typeof orderForm.validate === 'function' && !orderForm.validate()) {
      if (typeof orderForm.closeEasySellPopup === 'function') orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
      return false;
    }
    const accepted = orderForm.validateAndSubmit();
    if (!accepted) {
      if (typeof orderForm.closeEasySellPopup === 'function') orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
      return false;
    }
    const placed = await waitForEasySellOrder(orderForm, 20000);
    if (!placed && typeof orderForm.closeEasySellPopup === 'function') {
      orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
    }
    return placed;
  }

  function showThanks() {
    if (form) form.hidden = true;
    if (thanksEl) thanksEl.hidden = false;
    const sticky = root.querySelector('.qc-htc__sticky');
    if (sticky) sticky.hidden = true;
  }

  if (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      showError('');
      const name = (form.nom.value || '').trim();
      const phone = (form.telephone.value || '').trim();
      const city = (form.ville.value || '').trim();
      const address = (form.adresse.value || '').trim();
      if (!name || !phone || !city || !address) {
        showError('Merci de remplir tous les champs.');
        return;
      }
      if (!/^(?:\+?212|0)[5-8]\d{8}$/.test(phone.replace(/[\s.-]/g, ''))) {
        showError('Entrez un numéro marocain valide (06 / 07…).');
        return;
      }
      const variantId = Number(form.dataset.variant);
      if (!variantId) {
        showError('Impossible d’envoyer la commande. Réessayez.');
        return;
      }
      const submitBtn = form.querySelector('[type="submit"]');
      const original = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'جاري الإرسال…';
      }
      try {
        await fetch(cartClearUrl, { method: 'POST', headers: { Accept: 'application/json' } });
        const versionName = form.dataset.name || 'Pack 4 livres';
        const extras = form.dataset.books || '';
        const totalText = form.dataset.total || '';
        const addRes = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  Pack: versionName,
                  Version: 'Pack 4 livres',
                  'Livres de coloriage': extras,
                  Total: totalText,
                  Nom: name,
                  Téléphone: phone,
                  Ville: city,
                  Adresse: address,
                  Paiement: 'COD',
                },
              },
            ],
          }),
        });
        if (!addRes.ok) throw new Error('cart add failed');
        await fetch(cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            note:
              'Paiement à la livraison (COD) — Pack 4 livres de coloriage — ' +
              versionName +
              (totalText ? ' — ' + totalText : ''),
            attributes: {
              Nom: name,
              Téléphone: phone,
              Ville: city,
              Adresse: address,
              Paiement: 'Paiement à la livraison',
              Pack: versionName,
              'Livres de coloriage': extras,
              Total: totalText,
            },
          }),
        });
        const placed = await submitEasySellInBackground({
          name: name,
          phone: normalizePhone(phone),
          address: address + ' — ' + city,
          packPrice: currentTotal(),
        });
        document.body.classList.remove('qc-es-silent');
        if (placed) {
          showThanks();
          return;
        }
        showError('Impossible d’envoyer la commande. Réessayez.');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = original;
        }
      } catch (err) {
        document.body.classList.remove('qc-es-silent');
        showError('Impossible d’envoyer la commande. Réessayez.');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = original;
        }
      }
    });
  }
})();
